import { DynamicStandaloneLink, DynamicStandaloneLinkProps } from '@/components/Link';
import c from '@/styles/Navigation';
import { ClassNameProp, StandaloneComponent } from '@/types/component';
import getCurrentBrand from '@/utils/getCurrentBrand';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';
import mergeProps from 'lib/utils/mergeProps';

export interface NavigationLogoProps extends DynamicStandaloneLinkProps {
  options?: DynamicStandaloneLinkProps['options'] & {
    colors?: ClassNameProp<'default' | 'alternative'>;
    size?: ClassNameProp<'default' | 'alternative'>;
  };
}

export const NavigationLogoComponent: StandaloneComponent<NavigationLogoProps> = (props) => {
  const { colors, size, variant } = props?.options ?? {};

  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('logo_colors', colors);
  const sizeClassName = getPropStyles('logo_size', size);
  const variantClassName = getPropStyles('logo_variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName);

  const { name } = getCurrentBrand();

  return (
    <DynamicStandaloneLink
      {...mergeProps(
        {
          href: '/',
          options: { className: componentClassName, 'aria-label': `Länk till ${name}s startsida` },
        },
        props
      )}
    />
  );
};
